import React, { FC } from 'react'

import { IconPictureMessageProps } from './IconPictureMessage.types'
import * as Styled from './styles/IconPictureMessage.style'

import { nonThemeableRules } from '../../ruleSet'

const IconPictureMessage: FC<IconPictureMessageProps> = ({
  size = nonThemeableRules.defaultSize as number as IconPictureMessageProps['size'],
  isResponsive = false,
  appearance = 'primary',
  inverse = false,
  state,
}: IconPictureMessageProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive} appearance={appearance} inverse={inverse} state={state}>
      <svg viewBox='0 0 160 160' xmlns='http://www.w3.org/2000/svg'>
        <g fill='none' fillRule='evenodd'>
          <path d='M3.5 3.5h153v153H3.5z' stroke='#333' strokeWidth='7' />
          <text fill='#333' fontFamily='VodafoneRg-Regular, Vodafone Rg' fontSize='80'>
            <tspan x='16' y='107'>
              N/A
            </tspan>
          </text>
        </g>
      </svg>
    </Styled.IconWrapper>
  )
}

export default IconPictureMessage
